var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFilterIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.8843 4.66666H22.2176",
    stroke: "#BBBBBB",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.21753 4.66666H4.8842",
    stroke: "#BBBBBB",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2175 12H22.2175",
    stroke: "#BBBBBB",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.21753 12H12.2175",
    stroke: "#BBBBBB",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.5507 2C9.02337 2 10.2174 3.194 10.2174 4.66667C10.2174 6.13933 9.02337 7.33333 7.5507 7.33333C6.07803 7.33333 4.88403 6.13933 4.88403 4.66667C4.88403 3.194 6.07803 2 7.5507 2V2Z",
    stroke: "#BBBBBB",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8843 19.3334H22.2176",
    stroke: "#BBBBBB",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M2.21753 19.3334H4.8842",
    stroke: "#BBBBBB",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.5507 16.6667C9.02337 16.6667 10.2174 17.8607 10.2174 19.3334C10.2174 20.806 9.02337 22 7.5507 22C6.07803 22 4.88403 20.806 4.88403 19.3334C4.88403 17.8607 6.07803 16.6667 7.5507 16.6667V16.6667Z",
    stroke: "#BBBBBB",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.8842 9.33334C16.3569 9.33334 17.5509 10.5273 17.5509 12C17.5509 13.4727 16.3569 14.6667 14.8842 14.6667C13.4115 14.6667 12.2175 13.4727 12.2175 12C12.2175 10.5273 13.4115 9.33334 14.8842 9.33334V9.33334Z",
    stroke: "#BBBBBB",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterIcon);
export default __webpack_public_path__ + "static/media/filter-icon.0d01fdad35d30cc3f5d48e7e98530026.svg";
export { ForwardRef as ReactComponent };